<template>
  <div v-if="visible" class="story-player" @click="next">
    <!-- Dialogue -->
    <template v-if="currentItem.type === 'dialogue'">
      <div class="dialogue-container">
        <!-- 左侧角色 -->
        <div class="talk-box left">
          <img :src="getAvatar(currentItemLeft.name)" class="avatar" :class="[
            { active: currentItem.position === 'left' },
            currentItemLeft.class
          ]" />
          <div class="bubble" v-if="currentItem.position === 'left' && displayedText">
            <div class="text">{{ displayedText }}</div>
          </div>
        </div>

        <!-- 右侧角色 -->
        <div class="talk-box right">
          <div class="bubble" v-if="currentItem.position === 'right'">
            <div class="text">{{ displayedText }}</div>
          </div>
          <img :src="getAvatar(currentItemRight.name)" class="avatar" :class="[
            { active: currentItem.position === 'right' },
            currentItemRight.class
          ]" />
        </div>
      </div>
    </template>

    <!-- Black screen -->
    <transition name="fade" @after-leave="onBlackTransitionEnd">
      <div class="black-screen" v-if="currentItem.type === 'black'">
        <div class="black-text">{{ displayedText }}</div>
      </div>
    </transition>

    <!-- Image section -->
    <div class="special-image" v-if="currentItem.type === 'image'">
      <img :src="currentItem.image" />
      <p>{{ currentItem.content }}</p>
    </div>
    <!-- 上方返回按钮（在再次进入时显示） -->
    <div v-if="hasEnteredBefore" class="back-button" @click.stop="closeDialogue">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hasEnteredBefore: Boolean, // 是否是再次进入（可决定显示返回）
    visible: Boolean,
  },
  data() {
    return {
      currentIndex: 0,
      visibleItem: null,
      displayedText: '',
      typing: false,
      transitioning: false,
      typeTimer: null,
      autoTimer: null,
      script: [
        { type: 'dialogue', name: '尼克', position: 'left', content: '呼…终于都准备好了！辛苦大家了！', class: 'nike' },
        { type: 'dialogue', name: '姜娜', position: 'right', content: '尼克！！（气喘吁吁跑来）', class: 'jiangna' },
        { type: 'dialogue', name: '尼克', position: 'left', content: '姜娜？你怎么提前过来了，庆典还有一会儿开始呢。', class: 'nike' },
        { type: 'dialogue', name: '姜娜', position: 'right', content: '呼呼…还好赶上了。大家——准备好了吗！', class: 'jiangna' },
        { type: 'black', content: '众人合力推着2个巨型蛋糕走了出来…', autoplay: true, duration: 2000 },
        { type: 'dialogue', name: '众人', position: 'left', content: '尼克镇长，谢谢您这一年的付出！', class: 'all' },
        { type: 'dialogue', name: '姜娜', position: 'right', content: '亲爱的尼克镇长~这是我们大家准备的生日蛋糕，快来尝尝吧！', class: 'jiangna' },
        { type: 'dialogue', name: '尼克', position: 'left', content: '这…这是…谢谢你们…咦？还有个7？这是？', class: 'nike' },
        { type: 'dialogue', name: '尼奥&K', position: 'right', content: '臭小子，别忘了我们啊！', class: 'nike-k' },
        { type: 'black', content: '2025年8月8日\n《阿瑞斯病毒2》迎来一周年生日\n而阿瑞斯系列，已陪大家走过七个漫长岁月', autoplay: true, duration: 2500 },
        { type: 'black', content: '一路走来，不容易\n你的每一次探索，每一次战斗\n都书写着属于你的冒险故事\n谢谢你，一直坚守着，战斗着。', autoplay: true, duration: 3000 },
        { type: 'black', content: '未来的路还很长\n《阿瑞斯病毒2》的故事会一直延续\n我们会陪伴着你，走很久，很久…', autoplay: true, duration: 2500 },
        { type: 'dialogue', name: '众人', position: 'left', content: '尼克镇长，定时好了嘛？快过来！', class: 'all' },
        { type: 'dialogue', name: '尼克', position: 'right', content: 'OK了，这相机可真难捣鼓啊。', class: 'nike' },
        { type: 'black', autoplay: true, duration: 2000, content: '咔嚓——相机突然提前拍下了合影' }
      ],
      avatarMap: {
        '尼克': 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
        '姜娜': 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_jiangna.png',
        '众人': 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_zhongren.png',
        '尼奥&K': 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nikeK.png'
      }
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.currentIndex = 0
        this.scheduleAutoPlay(this.currentItem);;
      }
    },
  },
  methods: {
    closeDialogue() {
      this.$emit('end', 'back');
    },
    updateVisibleItem() {
      this.visibleItem = this.script[this.currentIndex];
      this.scheduleAutoPlay(this.visibleItem);
    },
    onBlackTransitionEnd() {
      this.transitioning = false;
      // 自动显示下一段（对话等）内容
      if (
        this.visibleItem &&
        this.visibleItem.type === 'black' &&
        this.visibleItem.autoplay
      ) {
        this.currentIndex++;
        this.updateVisibleItem();
      }
    },
    getAvatar(name) {
      return this.avatarMap[name] || '';
    },
    typeEffect(text, callback) {
      clearInterval(this.typeTimer);
      this.typing = true;
      this.displayedText = '';
      let i = 0;

      this.typeTimer = setInterval(() => {
        this.displayedText += text[i++];
        if (i >= text.length) {
          clearInterval(this.typeTimer);
          this.typing = false;
          callback && callback();
        }
      }, 60);
    },
    next() {
      // 防止在动画进行中点击跳过
      if (this.typing || this.transitioning) return;
      clearTimeout(this.autoTimer);

      // 允许打字快进
      // if (this.typing) {
      //   clearInterval(this.typeTimer);
      //   this.displayedText = this.currentItem.content;
      //   this.typing = false;
      //   return;
      // }

      if (this.currentIndex < this.script.length - 1) {
        const previousItem = this.currentItem;
        const nextItem = this.script[this.currentIndex + 1];
        this.currentIndex++;

        // 👉 如果上一条是 black，延迟 500ms 再切换，为了等黑幕慢慢消失
        if (previousItem.type === 'black' && nextItem.type !== 'black') {
          this.displayedText = ''
          this.transitioning = true; // 黑幕过渡中，禁止跳过
          setTimeout(() => {
            this.transitioning = false; // 过渡结束，解锁
            this.updateVisibleItem();
          }, 300); // 你也可以试试 600 或 800 看起来非常自然
        } else {
          this.updateVisibleItem(); // 正常立即切换
        }
      }
      else {
        this.$emit('end');
      }
    },
    scheduleAutoPlay(item) {
      if (!item) return;
      if (item.type === 'dialogue' || item.type === 'black') {
        this.typeEffect(item.content, () => {
          if (item.type === 'black' && item.autoplay) {
            this.autoTimer = setTimeout(() => this.next(), item.duration || 2000);
          }
        });
      } else {
        this.displayedText = item.content;
      }
    }
  },
  computed: {
    currentItem() {
      return this.script[this.currentIndex] || {};
    },
    currentNextItem() {
      const index = this.script.findIndex((item, index) => item.type === 'dialogue' && index > this.currentIndex)
      return this.script[index] || {};
    },
    currentBeforeItem() {
      for (let i = this.currentIndex - 1; i >= 0; i--) {
        if (this.script[i].type === 'dialogue') {
          return this.script[i];
        }
      }
      return {}; // 没找到就返回空对象
    },
    currentItemLeft() {
      return this.currentItem.position === 'right'
        ? this.script[this.currentIndex + 1].type === 'black' ? this.currentBeforeItem : this.currentNextItem
        : this.currentItem;
    },
    currentItemRight() {
      return this.currentItem.position === 'left'
        ? this.currentNextItem
        : this.currentItem;
    }
  },
  mounted() {
    // this.scheduleAutoPlay(this.currentItem);
  },
  beforeDestroy() {
    clearInterval(this.typeTimer);
    clearTimeout(this.autoTimer);
  }
};
</script>

<style scoped>
.story-player {
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  top: 0;
  background: url('https://download4.qcplay.com/h5-images/active/ares/anniversary/mengban.png')
    no-repeat;
  background-size: 100% 100%;
  z-index: 9999;
  transform: translateZ(100px);
}

.black-screen {
  background: #000;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  color: #fff;
  line-height: 1.8;
  white-space: pre-line;
  transition: all 5s;
}

.special-image {
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: fadeIn 0.5s;
}

.dialogue-container {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  pointer-events: auto;
  padding: 0 10px;
  transition: all 0.3s;
}
.talk-box {
  display: flex;
  align-items: flex-start;
  pointer-events: auto;
  cursor: pointer;
  margin-top: auto;
}
.talk-box.left {
  flex-direction: row;
  justify-content: flex-start;
}
.talk-box.right {
  margin-left: auto;
  justify-content: flex-end;
}
.avatar {
  width: 333px;
  height: 359px;
  margin: 0 4px;
  filter: grayscale(100%) brightness(0.6);
  transition: filter 0.3s;
}
.left .nike {
  width: 390px;
  height: 358px;
}
.right .nike {
  width: 390px;
  height: 358px;
}
.left .all {
  width: 575px;
  height: 375px;
}
.right .jiangna {
  width: 321px;
  height: 358px;
}
.right .nike-k {
  width: 479px;
  height: 357px;
}
.avatar.active {
  filter: none;
}
.bubble {
  background: #fff;
  border-radius: 12px;
  padding: 12px 16px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  color: #333;
  font-size: 24px;
  line-height: 1.4;
  max-width: 400px;
  min-width: 180px;
  position: relative;
  margin-top: 50px;
  min-height: 36px;
}
/* 泡泡尾巴 */
.bubble::after {
  content: '';
  position: absolute;
  top: 12px;
  width: 0;
  height: 0;
  border-style: solid;
}

/* 左侧角色说话 — 尾巴朝左 */
.talk-box.left .bubble::after {
  left: -10px;
  border-width: 14px 14px 14px 0;
  border-color: transparent #fff transparent transparent;
}

/* 右侧角色说话 — 尾巴朝右 */
.talk-box.right .bubble::after {
  right: -10px;
  border-width: 14px 0 14px 14px;
  border-color: transparent transparent transparent #fff;
}
.text {
  white-space: pre-line;
}
/* 黑幕进入：快速出现 */
.fade-enter-active {
  transition: opacity 0.1s ease-in;
}
.fade-leave-active {
  transition: opacity 0.4s ease-out;
}
.fade-enter {
  opacity: 0;
}
.fade-leave-to {
  opacity: 0;
}
.back-button {
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
  z-index: 1001;
  width: 191px;
  height: 79px;
  background: url('https://download4.qcplay.com/h5-images/active/ares/anniversary/btn_back.png')
    no-repeat;
  background-size: 100% 100%;
}
</style>


// WEBPACK FOOTER //
// src/pages/ares/anniversary/components/CakeModal.vue